/** Six digits from an authenticator app: one field, drawn as six boxes, the next one marked. */
export function CodeField({
  id,
  label,
  value,
  error,
  onChange,
}: {
  id: string;
  label: string;
  value: string;
  error: string | undefined;
  onChange: (value: string) => void;
}) {
  const boxes = Array.from({ length: 6 }, (_, at) => value.charAt(at));
  return (
    <div className="field">
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      <div className="code-boxes">
        <input
          id={id}
          className="code-input"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={6}
          value={value}
          aria-invalid={error !== undefined}
          aria-describedby={error === undefined ? undefined : `${id}-error`}
          onChange={(event) => {
            onChange(event.target.value.replace(/\D/g, '').slice(0, 6));
          }}
        />
        {boxes.map((digit, at) => (
          <span
            key={at}
            aria-hidden="true"
            className={at === value.length ? 'code-box code-box-next' : 'code-box'}
          >
            {digit}
          </span>
        ))}
      </div>
      {error !== undefined && (
        <p className="field-error" id={`${id}-error`}>
          {error}
        </p>
      )}
    </div>
  );
}
